import { clerkPlugin } from "vue-clerk";
import { defineNuxtPlugin, navigateTo, useRuntimeConfig, useState } from "#imports";
export default defineNuxtPlugin({
  name: "vue-clerk",
  setup(nuxtApp) {
    const initialState = useState("clerk-initial-state", () => void 0);
    if (import.meta.server) {
      initialState.value = nuxtApp.ssrContext?.event.context.__clerk_initial_state;
    }
    nuxtApp.vueApp.use(clerkPlugin, {
      ...useRuntimeConfig().public.clerk,
      routerPush: (to) => navigateTo(to),
      routerReplace: (to) => navigateTo(to, { replace: true }),
      initialState: initialState.value
    });
  }
});
